"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Scavengers = void 0;
var Card_1 = require("../../Card");
var CardName_1 = require("../../../CardName");
var CardType_1 = require("../../CardType");
var CardRenderer_1 = require("../../render/CardRenderer");
var TileType_1 = require("../../../TileType");
var SelectSpace_1 = require("../../../inputs/SelectSpace");
var Scavengers = (function (_super) {
    __extends(Scavengers, _super);
    function Scavengers() {
        return _super.call(this, {
            cardType: CardType_1.CardType.CORPORATION,
            name: CardName_1.CardName.SCAVENGERS,
            startingMegaCredits: 46,
            initialActionText: 'Place the crashed space ship tile on mars',
            metadata: {
                cardNumber: 'L421',
                description: 'You start with 46 M€ and 1 of every other resource. As your first action, place the crashed space ship tile on mars.',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.megacredits(46).wild(1).tile(TileType_1.TileType.SCAVENGERS, true);
                    b.corpBox('effect', function (ce) {
                        ce.effect('When you place a standard (non ocean) tile on mars, gain an additional bonus of each type printed on the tile.', function (eb) {
                            eb.text('n').wild(1).startEffect.text('(n+1)').wild(1);
                        });
                    });
                }),
            },
        }) || this;
    }
    Scavengers.prototype.initialAction = function (player) {
        var availableSpaces = player.game.board.getAvailableSpacesOnLand(player);
        return new SelectSpace_1.SelectSpace('Select space for tile', availableSpaces, function (foundSpace) {
            player.game.addTile(player, foundSpace.spaceType, foundSpace, { tileType: TileType_1.TileType.SCAVENGERS });
            return undefined;
        });
    };
    Scavengers.prototype.play = function (player) {
        player.steel++;
        player.titanium++;
        player.plants++;
        player.energy++;
        player.heat++;
        return undefined;
    };
    return Scavengers;
}(Card_1.Card));
exports.Scavengers = Scavengers;
//# sourceMappingURL=Scavengers.js.map